import { Col, Row, Statistic, StatisticProps } from 'antd';
import React, { useEffect } from 'react';
import CountUp from 'react-countup';
import { TimePeriod } from '../viewmodels/realtime-dashboard.view-model';
import { Filter } from './particles/Filter';
import { PerformanceOverallMetricType } from '@/domain/entities/real-time/performance-metric.entity';
import { CallOverViewType } from '@/domain/entities/real-time/sale-metric.entity';
import { formatTime } from '../helpers/format.helper';

type OverallProps = {
  call: CallOverViewType;
  performance: PerformanceOverallMetricType;
  filter: {
    timePeriod: TimePeriod;
  };
  setFilter: (filter: TimePeriod) => void;
};

type CardProps = {
  title: string;
  value: number;
  formatter: StatisticProps['formatter'];
};

export const Overall: React.FC<OverallProps> = (props) => {
  const formatter: StatisticProps['formatter'] = (value) => (
    <CountUp end={value as number} separator=',' />
  );
  const percentageFormatter: StatisticProps['formatter'] = (value) => (
    <CountUp end={(value as number) * 100} suffix='%' decimals={1} />
  );
  const secondsFormater: StatisticProps['formatter'] = (value) => {
    return formatTime(value as number);
  };
  const [callOverallCard, setCallOverallCard] = React.useState<CardProps[]>([]);
  useEffect(() => {
    setCallOverallCard([
      {
        title: 'Tổng cuộc gọi',
        value: props.call.totalCall,
        formatter,
      },
      {
        title: 'Tổng cuộc gọi nhấc máy',
        value: props.call.totalPickUpCall,
        formatter,
      },
      {
        title: 'Tổng thời gian gọi',
        value: props.call.totalCallDuration,
        formatter: secondsFormater,
      },
      {
        title: 'Số cuộc gọi trên salesman',
        value: props.call.totalCallPerSalesman,
        formatter,
      },
      {
        title: 'Số cuộc gọi nhấc máy trên salesman',
        value: props.call.averagePickUpCallPerSalesman,
        formatter,
      },
      {
        title: 'Thời lượng gọi trên salesman',
        value: props.call.averageCallDurationPerSalesman,
        formatter: secondsFormater,
      },
    ]);
  }, [props.call]);

  return (
    <div>
      <Row id={'top-overall'} gutter={16}>
        <Col span={8}>
          <Row gutter={10}>
            {callOverallCard &&
              callOverallCard.map((item, index) => (
                <Col span={8} key={index}>
                  <div className='bg-white mb-2 p-3 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200'>
                    <Statistic
                      title={<span className='text-gray-600 text-sm'>{item.title}</span>}
                      value={item.value}
                      formatter={item.formatter}
                      valueStyle={{ color: '#e31f26', fontWeight: 'bold' }}
                    />
                  </div>
                </Col>
              ))}
          </Row>
        </Col>
        <Col span={16}>
          <Row gutter={10}>
            <Col span={8}>
              <Row gutter={5}>
                <Col span={12}>
                  <div className='bg-white p-3 mb-2 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200'>
                    <Statistic
                      title={<span className='text-gray-600 text-sm'>Doanh thu tổng</span>}
                      value={props.performance.totalRevenue}
                      formatter={formatter}
                      valueStyle={{ color: '#e31f26', fontWeight: 'bold' }}
                    />
                  </div>
                </Col>
                <Col span={12}>
                  <div className='bg-white p-3 mb-2 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200'>
                    <Statistic
                      title={<span className='text-gray-600 text-sm'>Doanh thu KPI</span>}
                      value={props.performance.kpiProgress}
                      formatter={percentageFormatter}
                      valueStyle={{ color: '#e31f26', fontWeight: 'bold' }}
                    />
                  </div>
                </Col>
                <Col span={12}>
                  <div className='bg-white p-3 mb-2 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200'>
                    <Statistic
                      title={<span className='text-gray-600 text-sm'>CR45</span>}
                      value={props.performance.cr45}
                      formatter={percentageFormatter}
                      valueStyle={{ color: '#e31f26', fontWeight: 'bold' }}
                    />
                  </div>
                </Col>
                <Col span={12}>
                  <div className='bg-white p-3 mb-2 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200'>
                    <Statistic
                      title={<span className='text-gray-600 text-sm'>Doanh thu trên Salemans</span>}
                      value={props.performance.achievedPerSalesman}
                      formatter={formatter}
                      valueStyle={{ color: '#e31f26', fontWeight: 'bold' }}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col id='filter' span={16}>
              <div className='bg-white p-4 rounded-lg shadow-sm'>
                <Filter setFilter={props.setFilter} filter={props.filter} />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};
